module.exports = __webpack_public_path__ + "img/zhanli12.3f0690ed.jpg";